import { render } from "./termUse.vue?vue&type=template&id=61c92ede"
import script from "./termUse.vue?vue&type=script&lang=js"
export * from "./termUse.vue?vue&type=script&lang=js"

import "./termUse.vue?vue&type=style&index=0&id=61c92ede&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__